import { useObjectContext } from '@context/ItemZoneContext'
import * as Accordion from '@radix-ui/react-accordion'
import '../styles.css'
import GroupsAccordion from './GroupsAccordion'

export function TextureGroupEditor() {
  const { centerInfo, controlledValues, setControlledValues } = useObjectContext()

  function handleRootChange(value: string) {
    setControlledValues([...[value]])
  }

  if (!centerInfo) return null

  return (
    <article className='flex h-full flex-col overflow-hidden border-l-2 border-r-2 border-C/Color3'>
      <div className='scrollable-editor relative overflow-y-auto overflow-x-hidden'>
        <div className='z-0'>
          <Accordion.Root
            type='single'
            collapsible
            value={controlledValues.at(0)}
            defaultValue={controlledValues.at(0)}
            onValueChange={(value) => handleRootChange(value)}
          >
            <GroupsAccordion nestingLevel={0} />
          </Accordion.Root>
        </div>
      </div>
    </article>
  )
}
